import type { StainDto } from '../api/companions';
import type { PetBaseVariant } from '../compositor/assetPaths';
import type { Outfit } from './types';
import { usePetImage } from './usePetImage';

/** A static pet picture: the 2D PNG, swapped for its 3D snapshot when 3D is available. */
export function PetFace(props: {
  species: string; stage: string; variant?: PetBaseVariant; stains?: StainDto[]; outfit?: Outfit;
  alt: string; className?: string; width?: number; height?: number;
}) {
  const src = usePetImage(props.species, props.stage, props.variant, props.stains, props.outfit);
  return <img src={src} alt={props.alt} className={props.className} width={props.width} height={props.height} />;
}
